import { ApiAddress } from "@/services/apis"
import request from "@/services/request"
import { NozzleShape } from "./NozzleShape.modal"

export async function getNozzleShapes(): Promise<NozzleShape[]> {
  return await request.get(ApiAddress.GET_NOZZLE_SHAPES)
}

export async function createNozzleShapes(body: Omit<NozzleShape, 'id'>) {
  return await request.post(ApiAddress.NOZZLE_SHAPES, body)
}

export async function getNozzleShape(id: number) {
  return await request.get(ApiAddress.NOZZLE_SHAPE, {params: {id}})
}

export async function updateNozzleShape(id: number, body: Omit<NozzleShape, 'id'>) {
  return await request.put(ApiAddress.NOZZLE_SHAPE, body, {params: {id}})
}

export async function deleteNozzleShape(id: number) {
  return await request.delete(ApiAddress.NOZZLE_SHAPE, {params: {id}})
}
